var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1811_12494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 2.66655V6.66655M15.3334 6.66655H11.3334M15.3334 6.66655L12.2401 3.75989C11.5236 3.04303 10.6372 2.51936 9.66354 2.23774C8.68992 1.95612 7.66082 1.92572 6.67227 2.14939C5.68372 2.37306 4.76795 2.84351 4.01039 3.51683C3.25284 4.19016 2.67819 5.04441 2.34008 5.99989M0.666748 13.3332V9.33322M0.666748 9.33322H4.66675M0.666748 9.33322L3.76008 12.2399C4.47658 12.9567 5.363 13.4804 6.33662 13.762C7.31024 14.0437 8.33934 14.0741 9.32789 13.8504C10.3164 13.6267 11.2322 13.1563 11.9898 12.4829C12.7473 11.8096 13.322 10.9554 13.6601 9.99989",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1811_12494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResubmit);
export default __webpack_public_path__ + "static/media/resubmit.c55f99fef05161eeb9e98aafda0be6c4.svg";
export { ForwardRef as ReactComponent };